module.exports = __webpack_public_path__ + "static/encounter-with-a-dragon-dd017b3ddef9cb9210a04f036746ce75.png";